import deepMerge from 'deepmerge';
import {DefaultAppearanceConfig} from '@common/admin/appearance/config/default-appearance-config';
import {IAppearanceConfig} from '@common/admin/appearance/types/appearance-editor-config';

let mergedAppearanceConfig: IAppearanceConfig | null = null;

export async function getMergedAppearanceConfig(): Promise<IAppearanceConfig> {
  if (!mergedAppearanceConfig) {

    const {AppAppearanceConfig} = await import('@app/admin/appearance/app-appearance-config');
    mergedAppearanceConfig = deepMerge.all([
      DefaultAppearanceConfig,
      AppAppearanceConfig,
    ]) as IAppearanceConfig;
  }
  return mergedAppearanceConfig;
}


export default null as IAppearanceConfig | null;
